import * as React from 'react';
import { cn } from '../lib/cn.ts';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  'data-testid'?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex w-full rounded-md border border-[var(--color-input)]',
          'bg-[var(--color-alabaster)] px-3 py-2',
          'font-[var(--font-text)] text-sm text-[var(--color-charcoal)]',
          'placeholder:text-[var(--color-stone-mid)]',
          // Autosize: the field grows with its content (CSS `field-sizing`),
          // floored at ~2 rows and capped at 40vh where it starts scrolling.
          // `resize-y` stays as a manual drag override.
          'field-sizing-content min-h-[80px] max-h-[40vh] overflow-y-auto',
          'transition-colors resize-y',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:ring-offset-0 focus-visible:border-[var(--color-warm-stone)]',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--color-stone-100)]',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
